import { render, staticRenderFns } from "./ServiceDashboard.vue?vue&type=template&id=b4da4a76&scoped=true"
import script from "./ServiceDashboard.vue?vue&type=script&lang=js"
export * from "./ServiceDashboard.vue?vue&type=script&lang=js"
import style0 from "./ServiceDashboard.vue?vue&type=style&index=0&id=b4da4a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4da4a76",
  null
  
)

export default component.exports